module.exports = __webpack_public_path__ + "static/gatsby-icon-fa10d8e75868eb1a18cd5680436b2bf6.png";